import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { UAVCommandStore, UAVCommandState } from './uavcommand.store';

@Injectable({ providedIn: 'root' })
export class UAVCommandQuery extends QueryEntity<UAVCommandState> {

  constructor(protected store: UAVCommandStore) {
    super(store);
  }

}
